import { StyleSheet, View } from 'react-native';
import type { PhotoSearchImageSource } from '../../types/photoSearch';
import { tokens } from '../../theme/tokens';
import { EmptyView } from '../ui/EmptyView';
import { ErrorView } from '../ui/ErrorView';
import { PhotoSearchCaptureCard } from './PhotoSearchCaptureCard';

type CameraPreviewStatus = 'empty' | 'error' | 'success';

type CameraPreviewScreenProps = {
  imageUri: string | null;
  activeSource: PhotoSearchImageSource;
  status: CameraPreviewStatus;
  errorMessage: string;
  isSubmitting: boolean;
  onChangeSource: (source: PhotoSearchImageSource) => void;
  onPickImage: (source: PhotoSearchImageSource) => void;
  onSubmit: () => void;
  onToggleFlash: () => void;
  onRetry: () => void;
};

export function CameraPreviewScreen({
  imageUri,
  activeSource,
  status,
  errorMessage,
  isSubmitting,
  onChangeSource,
  onPickImage,
  onSubmit,
  onToggleFlash,
  onRetry,
}: CameraPreviewScreenProps) {
  return (
    <View style={styles.stack}>
      <PhotoSearchCaptureCard
        imageUri={imageUri}
        activeSource={activeSource}
        isSubmitting={isSubmitting}
        onChangeSource={onChangeSource}
        onPickImage={onPickImage}
        onSubmit={onSubmit}
        onToggleFlash={onToggleFlash}
      />

      {status === 'empty' ? (
        <EmptyView
          title="等待题图"
          description="拍照或从相册选择一道题后，就可以开始 OCR 识别和 AI 讲解。"
        />
      ) : null}

      {status === 'error' ? <ErrorView message={errorMessage} onRetry={onRetry} /> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  stack: {
    gap: tokens.spacing.lg,
  },
});
